// extracted by mini-css-extract-plugin
module.exports = {"image":"hero-media_image__2QAAB"};